import LicenseBuilderModel from "./tracked/licenseBuilderModel";
import Guid from "../helpers/guid";
import License from "../../formability/licenseBuilder/models/license";
import {DurationUnit} from "../enums/durationUnit";
import {Month} from "../enums/month";

export default class TimeOffset extends LicenseBuilderModel {
  type: number;
  day: number;
  month: number;
  amount: number;
  unit: number;
  text: string;

  constructor(license: License) {
    super();
    this.defineProperty('client_id', Guid.create());
    this.defineProperty('type', null);
    this.defineProperty('day', 31);
    this.defineProperty('month', Month.december);
    this.defineProperty('amount', 0);
    this.defineProperty('unit', DurationUnit.minute);
    this.defineProperty('text', '');
    this.parent = license;
    this.license = license;
  }

  get rootName(): string {
    return 'resources';
  }
}